import consumer from "./consumer";

const stations = {
  1: '961',
  2: '907'
}

const updateProgramInfo = (stationId) => {
  fetch("/api/v1/stations")
    .then((res) => res.json())
    .then((body) => {
      const station = body.data.stations.find((st) => stations[st.id] == stationId);
      const info = {
        id: stationId,
        name: station.name,
        frequency: station.frequency,
        logo: station.logo,
        live: true,
        src: station.feed_url,
        liveProgram: station.live_program,
      };
      localStorage.setItem("audioInfo", JSON.stringify(info));
      window.dispatchEvent(new Event("storage"));
    })
    .catch(console.warn);
};

consumer.subscriptions.create("LiveNotificationChannel", {
  received(data) {
    const audioInfo = JSON.parse(localStorage.getItem("audioInfo"))
    const stationId = audioInfo.id

    if (data.station == stationId) {
      updateProgramInfo(data.station);
    }

    // Called when there's incoming data on the websocket for this channel
    if (["/", "/live"].includes(document.location.pathname) && data.is_live) {
      window.location.reload();
    }
  },
});
